import React, { useState } from 'react';
import dayjs from 'dayjs';

import Column from 'components/common/Column';
import Text from 'components/common/Text';
import ModifyContainer from '../ModifyContainer';
import { ProductParamInput } from 'containers/ProductRegist/hooks/types';
import { ModifyValue } from '../../hooks/useProductDetaillHooks';

interface SaleTermContainerIProps {
  isMobile: boolean;
  productParamInput: ProductParamInput;
  modifyValue: ModifyValue;
  setModifyValue: React.Dispatch<React.SetStateAction<ModifyValue>>;
}

const SaleTermContainer: React.FC<SaleTermContainerIProps> = props => {
  const { isMobile, productParamInput, modifyValue, setModifyValue } = props;

  const saleTerm = productParamInput.saleTerm;

  return (
    <ModifyContainer
      title="판매 일정"
      isSelected={!isMobile && modifyValue.modifyStatus === 'saleTerm'}
      onClick={() => {
        setModifyValue({ ...modifyValue, modifyStatus: 'saleTerm' });
      }}
    >
      <Column gap="8px" align="flex-start">
        <Text color="#989BA2" size="16px" weight={400}>
          판매 시작일:{' '}
          <span style={{ color: '#414B56', fontWeight: 500 }}>
            {productParamInput.firstOpenedAt
              ? dayjs(productParamInput.firstOpenedAt).format(
                  'YYYY년 • M월 • D일',
                )
              : saleTerm && saleTerm.startedAt
                ? dayjs(saleTerm.startedAt).format('YYYY년 • M월 • D일')
                : '-'}
          </span>
        </Text>
        <Text color="#989BA2" size="16px" weight={400}>
          판매 종료일:{' '}
          <span style={{ color: '#414B56', fontWeight: 500 }}>
            {saleTerm && saleTerm.endedAt
              ? dayjs(saleTerm.endedAt).format('YYYY년 • M월 • D일')
              : '-'}
          </span>
        </Text>
      </Column>
    </ModifyContainer>
  );
};

export default SaleTermContainer;
